import { useSelector } from 'react-redux'
import { selectedDealership } from '../../store/selectors/dealershipSelector'
import { useQuery } from 'react-query'
import request from '../request'
import { useDealership } from '../../store/zustand/dealershipStore'
import { Vehicle } from '../../lib/types/Vehicle'

type ResultType = {
  totalVehicles?: number
  newVehicles?: number
  usedVehicles?: number
  newVehiclesObjects?: Array<Vehicle>
  usedVehiclesObjects?: Array<Vehicle>
  allVehicles?: Array<Vehicle>
  inventoryDataProviders?: {
    inventory_data_provider_ids: string[]
    inventory_data_provider_client_ids: string[]
  }
  totalCustomers?: number
  totalAudiences?: number
  sources?: any
}
export const useGetOverallStats = () => {
  const dealership = useDealership()

  return useQuery<ResultType, Error>(
    ['dealership', dealership?.id, 'stats'],
    () =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/stats/overall`,
        method: 'GET',
      }).then((res: any) => res.data),
    {
      enabled: !!dealership,
      refetchOnWindowFocus: false,
    },
  )
}
